module.exports = __webpack_public_path__ + "static/media/why-you-should-learn-ruby-on-rails.ad70cb9f.svg";